import styled from 'styled-components';
import { StyledMenuItemListProps } from './MenuItemList.types';

export const StyledMenuItemList = styled.div<StyledMenuItemListProps>`
  ${(props) => props.customStyle}
`;
